export default "__VITE_ASSET__B4VQr3TN__"